import React from 'react'
import { ProjectDiscountPayload } from 'src/core/models'
import styles from './ProjectDiscountMovileViewColumn.module.scss'
import {
  ProjectDiscountTypeColumn,
  ProjectDiscountAmountColumn,
  ProjectDiscountActionsColumn,
  ProjectDiscountAmountTypeColumn
} from 'src/components'

const ProjectDiscountMovileViewColumn: React.FC<{ discount: ProjectDiscountPayload }> = ({ discount }) => {
  return <div className={styles.content}>
    <div>
      <ProjectDiscountTypeColumn discount={discount} /> <br/>
      <ProjectDiscountAmountTypeColumn discount={discount} /> <br/>
      <ProjectDiscountAmountColumn discount={discount} />
    </div>
    <div className={styles.actions}>
      <ProjectDiscountActionsColumn discount={discount} />
    </div>
  </div>
}

export default ProjectDiscountMovileViewColumn
